export default function InteriorSpaces() {
  const spaces = [
    {
      title: 'Bedroom Zone',
      subtitle: 'Rest & Recharge',
      features: [
        'Queen platform bed',
        'Blackout smart glass',
        'Ambient sound system',
        'USB-C charging ports',
      ],
      dimensions: '12m² sleeping area',
      image: '/images/ai-minimalist-futuristic-bedroom-interior-w-2a9611.webp',
    },
    {
      title: 'Bathroom Sanctuary',
      subtitle: 'Spa-Grade Amenities',
      features: [
        'Rain shower',
        'Heated flooring',
        'Backlit mirror',
        'Eco-flush toilet',
      ],
      dimensions: '4m² bathroom',
      image: '/images/ai-modern-luxury-bathroom-interior-with-rai-f49a31.webp',
    },
    {
      title: 'Living Space',
      subtitle: 'Work & Unwind',
      features: [
        'Convertible desk',
        'Fiber internet ready',
        'Climate zones',
        'Storage solutions',
      ],
      dimensions: '8m² multipurpose area',
      image: '/images/ai-modern-minimalist-living-workspace-inter-c91795.webp',
    },
  ];

  return (
    <section id="interior" className="relative py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Panoramic Interior Image */}
        <div className="relative w-full h-[500px] rounded-2xl overflow-hidden mb-20">
          <img 
            src="/images/ai-ultra-wide-panoramic-interior-view-of-fu-67c969.webp" 
            alt="Interior Panoramic View"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent"></div>
        </div>

        {/* Overlapping Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 -mt-32 relative z-10">
          {spaces.map((space, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-[#14141e]/90 to-[#0a0a0f]/90 backdrop-blur-xl border border-cyan-500/30 rounded-lg p-8 hover:border-cyan-400/60 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,217,255,0.2)] hover:-translate-y-2 cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="w-full h-48 rounded-lg overflow-hidden mb-6">
                <img 
                  src={space.image} 
                  alt={space.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <h3 className="text-2xl font-medium mb-2 text-white">{space.title}</h3>
              <p className="text-cyan-400 text-sm mb-4">{space.subtitle}</p>

              {/* Features */}
              <ul className="space-y-2 mb-6">
                {space.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-400">
                    <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full"></div>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Dimensions */}
              <div className="pt-4 border-t border-gray-700">
                <span className="text-xs text-gray-500 uppercase tracking-wider">Dimensions</span>
                <p className="text-white font-medium mt-1">{space.dimensions}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Total Space */}
        <div className="text-center mt-16">
          <p className="text-xl text-gray-400">
            Total Living Space: <span className="text-cyan-400 font-medium text-2xl" style={{ textShadow: '0 0 20px rgba(0,217,255,0.5)' }}>24m²</span> of Optimised Luxury
          </p>
        </div>
      </div>
    </section>
  );
}